/* eslint-disable max-len */
import React, {FC} from "react"
import {withTheme, WithDefaultTheme} from "styled-components"

import BaseSvgIcon from "../Base"

interface Props extends WithDefaultTheme {}

const CircleInformationFill: FC<Props> = ({theme, ...props}) => {
  return (
    <BaseSvgIcon {...props} viewBox="0 0 16 16">
      <g clipPath="url(#clip0_12189_310)">
        <rect width="16" height="16" rx="8" fill="#6B6B6B" />
        <path
          d="M7.628 4.724C7.298 4.724 7.02667 4.62867 6.814 4.438C6.60867 4.24 6.506 3.998 6.506 3.712C6.506 3.41867 6.60867 3.17667 6.814 2.986C7.02667 2.788 7.298 2.689 7.628 2.689C7.95067 2.689 8.21467 2.788 8.42 2.986C8.63267 3.17667 8.739 3.41867 8.739 3.712C8.739 3.998 8.63267 4.24 8.42 4.438C8.21467 4.62867 7.95067 4.724 7.628 4.724ZM8.563 5.362V11.5H6.682V5.362H8.563Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_12189_310">
          <rect width="16" height="16" rx="8" fill="white" />
        </clipPath>
      </defs>
    </BaseSvgIcon>
  )
}

export default withTheme(CircleInformationFill)
